import type { QueryKey } from "@tanstack/query-core";
import type { UseQueryOptions, UseQueryResult } from "@tanstack/react-query";
import { useQuery } from "@tanstack/react-query";

/**
 * Custom useQuery hook for Rank Tracker with specific cache and refetch
 * settings. All options can still be overridden per-query.
 */
export const useRankTrackerQuery = <
    TQueryFnData = unknown,
    TError = Error,
    TData = TQueryFnData,
    TQueryKey extends QueryKey = QueryKey,
>(
    options: UseQueryOptions<TQueryFnData, TError, TData, TQueryKey>,
): UseQueryResult<TData, TError> => {
    return useQuery({
        staleTime: 5 * 60 * 1000,
        gcTime: 5 * 60 * 1000, // 5 minutes,
        refetchOnMount: true,
        ...options,
    });
};
